export const grammarData = {
  conditionals: [
    {
      tema: "First Conditional",
      estructura: "If + present, will + verb",
      ejemplo: "If it rains, we will stay home",
      traduccion: "Si llueve, nos quedaremos en casa",
      uso: "Situaciones reales/probables",
      id: "first"
    },
    {
      tema: "Second Conditional", 
      estructura: "If + past, would + verb",
      ejemplo: "If I won the lottery, I would travel",
      traduccion: "Si ganara la lotería, viajaría",
      uso: "Situaciones hipotéticas/improbables",
      id: "second"
    },
    {
      tema: "Third Conditional",
      estructura: "If + past perfect, would have + past participle", 
      ejemplo: "If I had studied, I would have passed",
      traduccion: "Si hubiera estudiado, habría aprobado",
      uso: "Situaciones del pasado (imposibles de cambiar)",
      id: "third"
    },
    {
      tema: "Comparative",
      estructura: "adj + er / more + adj + than",
      ejemplo: "She is taller than me / More beautiful than her sister",
      traduccion: "Ella es más alta que yo / Más bella que su hermana", 
      uso: "Comparar 2 cosas",
      id: "comparative"
    },
    {
      tema: "Superlative",
      estructura: "the + adj + est / the most + adj",
      ejemplo: "The tallest building / The most beautiful girl",
      traduccion: "El edificio más alto / La chica más bella",
      uso: "El máximo de 3 o más cosas",
      id: "superlative"
    }
  ],

  // FECHAS Y NÚMEROS - NUEVA SECCIÓN
  datesNumbers: [
    {
      tema: "Months of the Year",
      estructura: "January - December",
      ejemplo: "My birthday is in January / I was born on January 6th, 1980",
      traduccion: "Mi cumpleaños es en enero / Nací el 6 de enero de 1980",
      uso: "Use 'in' with months/years, 'on' with complete dates",
      id: "months"
    },
    {
      tema: "Cardinal Numbers (1-31)",
      estructura: "one, two, three, four, five...",
      ejemplo: "I have twenty-one books / There are thirty days in September",
      traduccion: "Tengo veintiún libros / Hay treinta días en septiembre",
      uso: "Para contar objetos y fechas completas",
      id: "cardinal"
    },
    {
      tema: "Ordinal Numbers (1st-31st)",
      estructura: "first, second, third, fourth, fifth...",
      ejemplo: "Today is the twenty-first of March",
      traduccion: "Hoy es veintiuno de marzo",
      uso: "Para orden, posición y fechas con mes",
      id: "ordinal"
    },
    {
      tema: "Date Prepositions",
      estructura: "in (months/years), on (dates)",
      ejemplo: "In 1995, on July 4th, on Monday",
      traduccion: "En 1995, el 4 de julio, el lunes",
      uso: "IN para períodos largos, ON para días específicos",
      id: "datePrep"
    }
  ],

  // WH-WORDS EXPANDIDO - NUEVA SECCIÓN
  whWords: [
    {
      tema: "What (Object/Action)",
      estructura: "What + verb/to be?",
      ejemplo: "What is this? / What are you doing?",
      traduccion: "¿Qué es esto? / ¿Qué estás haciendo?",
      uso: "Para objetos, situaciones, acciones",
      id: "what"
    },
    {
      tema: "Who (Person)",
      estructura: "Who + verb?",
      ejemplo: "Who is the new teacher? / Who helped you?",
      traduccion: "¿Quién es el nuevo profesor? / ¿Quién te ayudó?",
      uso: "Para identificar personas",
      id: "who"
    },
    {
      tema: "Where (Place)",
      estructura: "Where + do/does/did + subject + verb?",
      ejemplo: "Where do you work? / Where did you go?",
      traduccion: "¿Dónde trabajas? / ¿Dónde fuiste?",
      uso: "Para ubicación o lugar",
      id: "where"
    },
    {
      tema: "When (Time)",
      estructura: "When + do/does/did + subject + verb?",
      ejemplo: "When do you start work? / When did you arrive?",
      traduccion: "¿Cuándo empiezas a trabajar? / ¿Cuándo llegaste?",
      uso: "Para tiempo específico",
      id: "when"
    },
    {
      tema: "Why (Reason)",
      estructura: "Why + do/does/did + subject + verb?",
      ejemplo: "Why did you come late? / Why are you sad?",
      traduccion: "¿Por qué llegaste tarde? / ¿Por qué estás triste?",
      uso: "Para razones - respuesta con 'because'",
      id: "why"
    },
    {
      tema: "How (Manner/Frequency)",
      estructura: "How + do/does/did + subject + verb?",
      ejemplo: "How do you spell that? / How often do you exercise?",
      traduccion: "¿Cómo deletreas eso? / ¿Qué tan seguido haces ejercicio?",
      uso: "Para manera, frecuencia, cantidad",
      id: "how"
    },
    {
      tema: "Which (Choice)",
      estructura: "Which + noun + do/does + subject + prefer?",
      ejemplo: "Which car do you prefer, the red one or the blue one?",
      traduccion: "¿Qué auto prefieres, el rojo o el azul?",
      uso: "Para elegir entre opciones limitadas",
      id: "which"
    },
    {
      tema: "Whose (Possession)",
      estructura: "Whose + noun + is this?",
      ejemplo: "Whose car is this? / Whose book are you reading?",
      traduccion: "¿De quién es este auto? / ¿De quién es el libro que lees?",
      uso: "Para indicar posesión",
      id: "whose"
    }
  ],

  // COMPUTER VOCABULARY - NUEVA SECCIÓN
  computerVocab: [
    {
      tema: "Hardware Components",
      estructura: "Physical computer parts",
      ejemplo: "CPU, hard disk, mouse, monitor, keyboard, printer",
      traduccion: "CPU, disco duro, ratón, monitor, teclado, impresora",
      uso: "Partes físicas de la computadora",
      id: "hardware"
    },
    {
      tema: "Software Types",
      estructura: "Computer programs",
      ejemplo: "Operating system, antivirus, application software",
      traduccion: "Sistema operativo, antivirus, software de aplicación",
      uso: "Programas y sistemas de computadora",
      id: "software"
    },
    {
      tema: "File Management Verbs",
      estructura: "Computer actions",
      ejemplo: "Create, save, close, move, erase, rename, upload, download",
      traduccion: "Crear, guardar, cerrar, mover, borrar, renombrar, subir, descargar",
      uso: "Acciones con archivos y documentos",
      id: "fileManagement"
    },
    {
      tema: "Internet Expressions",
      estructura: "Online activities",
      ejemplo: "Connect to internet, surf the web, send emails",
      traduccion: "Conectarse a internet, navegar en la web, enviar emails",
      uso: "Actividades en línea",
      id: "internet"
    },
    {
      tema: "Document Formatting",
      estructura: "Text editing features",
      ejemplo: "Font, size, bold, italics, underline, copy, paste",
      traduccion: "Fuente, tamaño, negrita, cursiva, subrayado, copiar, pegar",
      uso: "Formato de documentos",
      id: "formatting"
    }
  ],

  // MEDICAL VOCABULARY - NUEVA SECCIÓN
  medicalVocab: [
    {
      tema: "Medical Professionals",
      estructura: "Healthcare workers",
      ejemplo: "Doctor, nurse, surgeon, therapist, specialist",
      traduccion: "Doctor, enfermero/a, cirujano, terapeuta, especialista",
      uso: "Profesionales de la salud",
      id: "medicalWorkers"
    },
    {
      tema: "Body Parts",
      estructura: "Parts of human body",
      ejemplo: "Head, shoulders, arms, chest, legs, feet",
      traduccion: "Cabeza, hombros, brazos, pecho, piernas, pies",
      uso: "Partes del cuerpo humano",
      id: "bodyParts"
    },
    {
      tema: "Common Ailments",
      estructura: "Health problems",
      ejemplo: "Headache, fever, cold, cough, stomachache",
      traduccion: "Dolor de cabeza, fiebre, resfriado, tos, dolor de estómago",
      uso: "Problemas de salud comunes",
      id: "ailments"
    },
    {
      tema: "Symptoms",
      estructura: "Signs of illness",
      ejemplo: "Tired, dizzy, nauseous, congested, pain",
      traduccion: "Cansado, mareado, nauseabundo, congestionado, dolor",
      uso: "Síntomas de enfermedades",
      id: "symptoms"
    },
    {
      tema: "Medical Advice",
      estructura: "Treatment recommendations",
      ejemplo: "Rest in bed, drink fluids, take medicine, see a doctor",
      traduccion: "Descansar en cama, tomar líquidos, tomar medicina, ver un doctor",
      uso: "Consejos médicos",
      id: "medicalAdvice"
    }
  ],
  
  tagQuestions: [
    {
      tema: "Tag Questions (Positivo → Negativo)",
      estructura: "Positive statement + negative tag",
      ejemplo: "You are a teacher, aren't you?",
      traduccion: "Eres profesor, ¿no?",
      uso: "Confirmar información",
      id: "positive-tag"
    },
    {
      tema: "Tag Questions (Negativo → Positivo)",
      estructura: "Negative statement + positive tag",
      ejemplo: "You aren't a doctor, are you?",
      traduccion: "No eres doctor, ¿verdad?",
      uso: "Confirmar información negativa",
      id: "negative-tag"
    },
    {
      tema: "Countable Nouns",
      estructura: "Nouns you can count (1, 2, 3...)",
      ejemplo: "One book, two cars, three apples",
      traduccion: "Un libro, dos autos, tres manzanas",
      uso: "Objetos que se pueden contar",
      id: "countable"
    },
    {
      tema: "Uncountable Nouns",
      estructura: "Nouns you cannot count",
      ejemplo: "Water, milk, money, information",
      traduccion: "Agua, leche, dinero, información",
      uso: "Sustancias, líquidos, conceptos abstractos",
      id: "uncountable"
    },
    {
      tema: "Some/Any/No Rules",
      estructura: "Some (+), Any (?/-), No (neg without not)",
      ejemplo: "Some cookies / Any questions? / No problem",
      traduccion: "Algunas galletas / ¿Alguna pregunta? / No hay problema",
      uso: "Cantidades indefinidas",
      id: "some-any-no"
    }
  ],

  verbTenses: [
    {
      tema: "Simple Present",
      estructura: "Subject + verb (s/es for 3rd person)",
      ejemplo: "I work / He works every day",
      traduccion: "Yo trabajo / Él trabaja todos los días",
      uso: "Rutinas, hechos, verdades generales",
      id: "simple-present"
    },
    {
      tema: "Present Continuous",
      estructura: "Subject + am/is/are + verb-ing",
      ejemplo: "I am working now / She is reading",
      traduccion: "Estoy trabajando ahora / Ella está leyendo",
      uso: "Acciones en progreso ahora",
      id: "present-continuous"
    },
    {
      tema: "Simple Past",
      estructura: "Subject + verb-ed (or irregular)",
      ejemplo: "I worked yesterday / He went home",
      traduccion: "Trabajé ayer / Él fue a casa",
      uso: "Acciones terminadas en el pasado",
      id: "simple-past"
    },
    {
      tema: "Past Continuous",
      estructura: "Subject + was/were + verb-ing",
      ejemplo: "I was working when you called",
      traduccion: "Estaba trabajando cuando llamaste",
      uso: "Acciones en progreso en el pasado",
      id: "past-continuous"
    },
    {
      tema: "Present Perfect",
      estructura: "Subject + have/has + past participle",
      ejemplo: "I have lived here for 5 years",
      traduccion: "He vivido aquí por 5 años",
      uso: "Experiencias, acciones que afectan el presente",
      id: "present-perfect"
    },
    {
      tema: "Past Perfect",
      estructura: "Subject + had + past participle",
      ejemplo: "I had finished before he arrived",
      traduccion: "Había terminado antes de que él llegara",
      uso: "Acción pasada antes de otra acción pasada",
      id: "past-perfect"
    },
    {
      tema: "Future Simple",
      estructura: "Subject + will + verb",
      ejemplo: "I will travel tomorrow",
      traduccion: "Viajaré mañana",
      uso: "Decisiones espontáneas, predicciones",
      id: "future-simple"
    },
    {
      tema: "Going to Future",
      estructura: "Subject + am/is/are + going to + verb",
      ejemplo: "I am going to study tonight",
      traduccion: "Voy a estudiar esta noche",
      uso: "Planes definidos, intenciones",
      id: "going-to-future"
    }
  ],

  modalVerbs: [
    {
      tema: "Can (Ability/Permission)",
      estructura: "Subject + can + verb",
      ejemplo: "I can swim / Can I help you?",
      traduccion: "Puedo nadar / ¿Puedo ayudarte?",
      uso: "Habilidad presente, permiso informal",
      id: "can"
    },
    {
      tema: "Could (Past ability/Polite request)",
      estructura: "Subject + could + verb",
      ejemplo: "I could swim when I was 5 / Could you help me?",
      traduccion: "Podía nadar cuando tenía 5 / ¿Podrías ayudarme?",
      uso: "Habilidad pasada, solicitud cortés",
      id: "could"
    },
    {
      tema: "Must (Strong obligation)",
      estructura: "Subject + must + verb",
      ejemplo: "You must study for the exam",
      traduccion: "Debes estudiar para el examen",
      uso: "Obligación fuerte, deducción lógica (99%)",
      id: "must"
    },
    {
      tema: "Should (Advice)",
      estructura: "Subject + should + verb",
      ejemplo: "You should eat more vegetables",
      traduccion: "Deberías comer más vegetales",
      uso: "Consejo, recomendación (50%)",
      id: "should"
    },
    {
      tema: "May (Permission/Possibility)",
      estructura: "Subject + may + verb",
      ejemplo: "May I sit here? / It may rain",
      traduccion: "¿Puedo sentarme aquí? / Puede que llueva",
      uso: "Permiso formal, posibilidad (50%)",
      id: "may"
    },
    {
      tema: "Might (Possibility)",
      estructura: "Subject + might + verb",
      ejemplo: "I might go to the party",
      traduccion: "Podría ir a la fiesta",
      uso: "Posibilidad menor (30%)",
      id: "might"
    }
  ],

  modalVerbsPast: [
    {
      tema: "Must have (Past deduction 99%)",
      estructura: "Subject + must have + past participle",
      ejemplo: "He must have forgotten the meeting",
      traduccion: "Debe haber olvidado la reunión",
      uso: "Deducción fuerte sobre el pasado",
      id: "must-have"
    },
    {
      tema: "Can't have (Impossible past)",
      estructura: "Subject + can't have + past participle",
      ejemplo: "She can't have said that",
      traduccion: "No puede haber dicho eso",
      uso: "Imposibilidad en el pasado",
      id: "cant-have"
    },
    {
      tema: "Could have (Past possibility)",
      estructura: "Subject + could have + past participle",
      ejemplo: "You could have called me",
      traduccion: "Podrías haberme llamado",
      uso: "Posibilidad pasada no realizada",
      id: "could-have"
    },
    {
      tema: "Should have (Past advice)",
      estructura: "Subject + should have + past participle",
      ejemplo: "I should have studied harder",
      traduccion: "Debería haber estudiado más",
      uso: "Consejo sobre acción pasada no realizada",
      id: "should-have"
    }
  ],

  // PHRASAL VERBS SÚPER EXPANDIDO
  phrasalVerbs: [
    // Phrasal Verbs más comunes
    {
      tema: "Look up",
      estructura: "Look + up = search for information",
      ejemplo: "I need to look up this word in the dictionary",
      traduccion: "Necesito buscar esta palabra en el diccionario",
      uso: "Buscar información",
      id: "look-up"
    },
    {
      tema: "Turn on/off",
      estructura: "Turn + on/off = start/stop machine",
      ejemplo: "Turn on the lights / Turn off the TV",
      traduccion: "Enciende las luces / Apaga la TV",
      uso: "Encender/apagar aparatos",
      id: "turn-on-off"
    },
    {
      tema: "Get up",
      estructura: "Get + up = arise from bed",
      ejemplo: "I get up at 7 AM every day",
      traduccion: "Me levanto a las 7 AM todos los días",
      uso: "Levantarse de la cama",
      id: "get-up"
    },
    {
      tema: "Give up",
      estructura: "Give + up = stop trying",
      ejemplo: "Don't give up on your dreams",
      traduccion: "No te rindas con tus sueños",
      uso: "Rendirse, dejar de intentar",
      id: "give-up"
    },
    {
      tema: "Put on/off",
      estructura: "Put + on = wear clothes / Put + off = postpone",
      ejemplo: "Put on your jacket / Let's put off the meeting",
      traduccion: "Ponte la chaqueta / Pospongamos la reunión",
      uso: "Ponerse ropa / posponer",
      id: "put-on-off"
    },
    {
      tema: "Take off",
      estructura: "Take + off = remove clothes or leave",
      ejemplo: "Take off your shoes / The plane takes off at 3 PM",
      traduccion: "Quítate los zapatos / El avión despega a las 3 PM",
      uso: "Quitarse ropa / despegar",
      id: "take-off"
    },
    {
      tema: "Pick up",
      estructura: "Pick + up = collect or answer phone",
      ejemplo: "Pick up your clothes / Pick up the phone",
      traduccion: "Recoge tu ropa / Contesta el teléfono",
      uso: "Recoger / contestar teléfono",
      id: "pick-up"
    },
    {
      tema: "Drop off",
      estructura: "Drop + off = leave someone/something",
      ejemplo: "I'll drop you off at school",
      traduccion: "Te dejaré en la escuela",
      uso: "Dejar a alguien en un lugar",
      id: "drop-off"
    },
    {
      tema: "Find out",
      estructura: "Find + out = discover information",
      ejemplo: "I need to find out what happened",
      traduccion: "Necesito averiguar qué pasó",
      uso: "Descubrir información",
      id: "find-out"
    },
    {
      tema: "Work out",
      estructura: "Work + out = exercise or solve",
      ejemplo: "I work out every morning / Let's work out this problem",
      traduccion: "Hago ejercicio cada mañana / Resolvamos este problema",
      uso: "Hacer ejercicio / resolver problemas",
      id: "work-out"
    },
    {
      tema: "Come back",
      estructura: "Come + back = return",
      ejemplo: "When will you come back from vacation?",
      traduccion: "¿Cuándo regresarás de vacaciones?",
      uso: "Regresar, volver",
      id: "come-back"
    },
    {
      tema: "Go out",
      estructura: "Go + out = leave home for entertainment",
      ejemplo: "Let's go out for dinner tonight",
      traduccion: "Salgamos a cenar esta noche",
      uso: "Salir a divertirse",
      id: "go-out"
    },
    {
      tema: "Break down",
      estructura: "Break + down = stop working (machine)",
      ejemplo: "My car broke down on the highway",
      traduccion: "Mi auto se descompuso en la autopista",
      uso: "Descomponerse (máquinas)",
      id: "break-down"
    },
    {
      tema: "Call back",
      estructura: "Call + back = return a phone call",
      ejemplo: "I'll call you back in 10 minutes",
      traduccion: "Te devuelvo la llamada en 10 minutos",
      uso: "Devolver una llamada",
      id: "call-back"
    },
    {
      tema: "Fill out",
      estructura: "Fill + out = complete a form",
      ejemplo: "Please fill out this application form",
      traduccion: "Por favor completa este formulario",
      uso: "Llenar formularios",
      id: "fill-out"
    },
    {
      tema: "Run out",
      estructura: "Run + out = have no more",
      ejemplo: "We're running out of time",
      traduccion: "Se nos está acabando el tiempo",
      uso: "Quedarse sin algo",
      id: "run-out"
    },
    {
      tema: "Show up",
      estructura: "Show + up = appear, arrive",
      ejemplo: "He didn't show up to the meeting",
      traduccion: "No apareció en la reunión",
      uso: "Aparecer, llegar",
      id: "show-up"
    },
    {
      tema: "Hang out",
      estructura: "Hang + out = spend time casually",
      ejemplo: "Let's hang out this weekend",
      traduccion: "Pasemos el rato este fin de semana",
      uso: "Pasar tiempo de forma casual",
      id: "hang-out"
    },
    {
      tema: "Set up",
      estructura: "Set + up = arrange or establish",
      ejemplo: "Let's set up a meeting for tomorrow",
      traduccion: "Organicemos una reunión para mañana",
      uso: "Organizar, establecer",
      id: "set-up"
    },
    {
      tema: "Clean up",
      estructura: "Clean + up = make tidy",
      ejemplo: "Clean up your room before dinner",
      traduccion: "Limpia tu cuarto antes de cenar",
      uso: "Limpiar, ordenar",
      id: "clean-up"
    },
    {
      tema: "Catch up",
      estructura: "Catch + up = reach the same level",
      ejemplo: "I need to catch up on my homework",
      traduccion: "Necesito ponerme al día con mi tarea",
      uso: "Ponerse al día",
      id: "catch-up"
    },
    {
      tema: "Back up",
      estructura: "Back + up = make a copy or support",
      ejemplo: "Back up your files / I'll back you up",
      traduccion: "Respalda tus archivos / Te apoyaré",
      uso: "Respaldar archivos / apoyar",
      id: "back-up"
    },
    {
      tema: "Cut down",
      estructura: "Cut + down = reduce",
      ejemplo: "I need to cut down on sugar",
      traduccion: "Necesito reducir el azúcar",
      uso: "Reducir, disminuir",
      id: "cut-down"
    },
    {
      tema: "Bring up",
      estructura: "Bring + up = mention a topic",
      ejemplo: "Don't bring up that topic again",
      traduccion: "No menciones ese tema otra vez",
      uso: "Mencionar un tema",
      id: "bring-up"
    },
    {
      tema: "Check out",
      estructura: "Check + out = examine or leave hotel",
      ejemplo: "Check out this new restaurant / We check out at noon",
      traduccion: "Mira este nuevo restaurante / Salimos del hotel al mediodía",
      uso: "Examinar / dejar hotel",
      id: "check-out"
    }
  ],

  // VERBOS IRREGULARES SÚPER EXPANDIDO
  irregularVerbs: [
    { 
      infinitive: "be", 
      past: "was/were", 
      pastParticiple: "been", 
      translation: "ser/estar",
      emoji: "🧬",
      examples: [
        { en: "I am happy", es: "Yo soy/estoy feliz" },
        { en: "She was tired yesterday", es: "Ella estaba cansada ayer" },
        { en: "They have been friends since childhood", es: "Han sido amigos desde la infancia" }
      ]
    },
    { 
      infinitive: "have", 
      past: "had", 
      pastParticiple: "had", 
      translation: "tener",
      emoji: "🤲",
      examples: [
        { en: "I have a car", es: "Tengo un carro" },
        { en: "She had lunch at noon", es: "Ella almorzó al mediodía" },
        { en: "We have had this house for 10 years", es: "Hemos tenido esta casa por 10 años" }
      ]
    },
    { 
      infinitive: "do", 
      past: "did", 
      pastParticiple: "done", 
      translation: "hacer",
      emoji: "✨",
      examples: [
        { en: "I do my homework every day", es: "Hago mi tarea todos los días" },
        { en: "He did a great job", es: "Hizo un gran trabajo" },
        { en: "The work has been done", es: "El trabajo ha sido hecho" }
      ]
    },
    { 
      infinitive: "say", 
      past: "said", 
      pastParticiple: "said", 
      translation: "decir",
      emoji: "💬",
      examples: [
        { en: "I say hello every morning", es: "Digo hola todas las mañanas" },
        { en: "She said goodbye", es: "Ella dijo adiós" },
        { en: "It has been said many times", es: "Se ha dicho muchas veces" }
      ]
    },
    { 
      infinitive: "go", 
      past: "went", 
      pastParticiple: "gone", 
      translation: "ir",
      emoji: "🚶‍♂️",
      examples: [
        { en: "I go to school every day", es: "Voy a la escuela todos los días" },
        { en: "They went to the movies", es: "Fueron al cine" },
        { en: "He has gone home", es: "Se ha ido a casa" }
      ]
    },
    { 
      infinitive: "get", 
      past: "got", 
      pastParticiple: "gotten/got", 
      translation: "obtener",
      emoji: "🎁",
      examples: [
        { en: "I get up at 7am", es: "Me levanto a las 7am" },
        { en: "She got a new job", es: "Ella consiguió un nuevo trabajo" },
        { en: "We have gotten better results", es: "Hemos obtenido mejores resultados" }
      ]
    },
    { 
      infinitive: "make", 
      past: "made", 
      pastParticiple: "made", 
      translation: "hacer",
      emoji: "🔨",
      examples: [
        { en: "I make breakfast every morning", es: "Hago desayuno todas las mañanas" },
        { en: "He made a mistake", es: "Él cometió un error" },
        { en: "This cake was made by my mom", es: "Este pastel fue hecho por mi mamá" }
      ]
    },
    { 
      infinitive: "know", 
      past: "knew", 
      pastParticiple: "known", 
      translation: "saber/conocer",
      emoji: "🧠",
      examples: [
        { en: "I know the answer", es: "Sé la respuesta" },
        { en: "She knew him in college", es: "Ella lo conoció en la universidad" },
        { en: "This place has been known for years", es: "Este lugar ha sido conocido por años" }
      ]
    },
    { 
      infinitive: "think", 
      past: "thought", 
      pastParticiple: "thought", 
      translation: "pensar",
      emoji: "💭",
      examples: [
        { en: "I think it's a good idea", es: "Pienso que es una buena idea" },
        { en: "He thought about it all night", es: "Él pensó en eso toda la noche" },
        { en: "It was well thought out", es: "Estaba bien pensado" }
      ]
    },
    { 
      infinitive: "take", 
      past: "took", 
      pastParticiple: "taken", 
      translation: "tomar",
      emoji: "✋",
      examples: [
        { en: "I take the bus to work", es: "Tomo el autobús al trabajo" },
        { en: "She took my advice", es: "Ella siguió mi consejo" },
        { en: "The last piece has been taken", es: "La última pieza ha sido tomada" }
      ]
    },
    { 
      infinitive: "see", 
      past: "saw", 
      pastParticiple: "seen", 
      translation: "ver",
      emoji: "👁️",
      examples: [
        { en: "I see you every day", es: "Te veo todos los días" },
        { en: "We saw a movie last night", es: "Vimos una película anoche" },
        { en: "Have you seen my keys?", es: "¿Has visto mis llaves?" }
      ]
    },
    { 
      infinitive: "come", 
      past: "came", 
      pastParticiple: "come", 
      translation: "venir",
      emoji: "👋",
      examples: [
        { en: "Please come here", es: "Por favor ven aquí" },
        { en: "She came to the party", es: "Ella vino a la fiesta" },
        { en: "He has come a long way", es: "Él ha recorrido un largo camino" }
      ]
    },
    { 
      infinitive: "give", 
      past: "gave", 
      pastParticiple: "given", 
      translation: "dar",
      emoji: "🎁",
      examples: [
        { en: "I give my best effort", es: "Doy mi mejor esfuerzo" },
        { en: "He gave me a gift", es: "Él me dio un regalo" },
        { en: "The award was given to her", es: "El premio le fue dado a ella" }
      ]
    },
    { 
      infinitive: "find", 
      past: "found", 
      pastParticiple: "found", 
      translation: "encontrar",
      emoji: "🔍",
      examples: [
        { en: "I find this interesting", es: "Encuentro esto interesante" },
        { en: "She found her wallet", es: "Ella encontró su billetera" },
        { en: "The solution has been found", es: "La solución ha sido encontrada" }
      ]
    },
    { 
      infinitive: "tell", 
      past: "told", 
      pastParticiple: "told", 
      translation: "decir/contar",
      emoji: "📢",
      examples: [
        { en: "I tell the truth", es: "Digo la verdad" },
        { en: "She told me a story", es: "Ella me contó una historia" },
        { en: "The story has been told many times", es: "La historia ha sido contada muchas veces" }
      ]
    },
    { infinitive: "work", past: "worked", pastParticiple: "worked", translation: "trabajar" },
    { infinitive: "call", past: "called", pastParticiple: "called", translation: "llamar" },
    { infinitive: "try", past: "tried", pastParticiple: "tried", translation: "intentar" },
    { infinitive: "ask", past: "asked", pastParticiple: "asked", translation: "preguntar" },
    { infinitive: "need", past: "needed", pastParticiple: "needed", translation: "necesitar" },
    { 
      infinitive: "feel", 
      past: "felt", 
      pastParticiple: "felt", 
      translation: "sentir",
      emoji: "❤️",
      examples: [
        { en: "I feel happy today", es: "Me siento feliz hoy" },
        { en: "She felt sad yesterday", es: "Ella se sintió triste ayer" },
        { en: "He has felt this way before", es: "Él se ha sentido así antes" }
      ]
    },
    { 
      infinitive: "become", 
      past: "became", 
      pastParticiple: "become", 
      translation: "convertirse",
      emoji: "🦋",
      examples: [
        { en: "I want to become a doctor", es: "Quiero convertirme en doctor" },
        { en: "She became famous overnight", es: "Ella se volvió famosa de la noche a la mañana" },
        { en: "He has become very successful", es: "Él se ha vuelto muy exitoso" }
      ]
    },
    { 
      infinitive: "leave", 
      past: "left", 
      pastParticiple: "left", 
      translation: "dejar/salir",
      emoji: "🚪",
      examples: [
        { en: "I leave work at 5pm", es: "Salgo del trabajo a las 5pm" },
        { en: "They left the party early", es: "Ellos se fueron de la fiesta temprano" },
        { en: "The train has left the station", es: "El tren ha salido de la estación" }
      ]
    },
    { 
      infinitive: "put", 
      past: "put", 
      pastParticiple: "put", 
      translation: "poner",
      emoji: "📍",
      examples: [
        { en: "I put my keys on the table", es: "Pongo mis llaves en la mesa" },
        { en: "She put the book on the shelf", es: "Ella puso el libro en el estante" },
        { en: "The items have been put away", es: "Los artículos han sido guardados" }
      ]
    },
    { 
      infinitive: "mean", 
      past: "meant", 
      pastParticiple: "meant", 
      translation: "significar",
      emoji: "💭",
      examples: [
        { en: "What do you mean?", es: "¿Qué quieres decir?" },
        { en: "I meant to call you", es: "Quería llamarte" },
        { en: "This was meant to be", es: "Esto estaba destinado a ser" }
      ]
    },
    { 
      infinitive: "keep", 
      past: "kept", 
      pastParticiple: "kept", 
      translation: "mantener",
      emoji: "🔒",
      examples: [
        { en: "I keep my money in the bank", es: "Mantengo mi dinero en el banco" },
        { en: "She kept the secret", es: "Ella guardó el secreto" },
        { en: "The tradition has been kept alive", es: "La tradición se ha mantenido viva" }
      ]
    },
    { 
      infinitive: "let", 
      past: "let", 
      pastParticiple: "let", 
      translation: "dejar/permitir",
      emoji: "✅",
      examples: [
        { en: "Please let me help you", es: "Por favor déjame ayudarte" },
        { en: "She let him go", es: "Ella lo dejó ir" },
        { en: "They have been let down", es: "Han sido decepcionados" }
      ]
    },
    { 
      infinitive: "begin", 
      past: "began", 
      pastParticiple: "begun", 
      translation: "comenzar",
      emoji: "🚀",
      examples: [
        { en: "Let's begin the meeting", es: "Comencemos la reunión" },
        { en: "The show began at 8pm", es: "El show comenzó a las 8pm" },
        { en: "The project has just begun", es: "El proyecto acaba de comenzar" }
      ]
    },
    { 
      infinitive: "bring", 
      past: "brought", 
      pastParticiple: "brought", 
      translation: "traer",
      emoji: "📦",
      examples: [
        { en: "Please bring your passport", es: "Por favor trae tu pasaporte" },
        { en: "She brought flowers", es: "Ella trajo flores" },
        { en: "The food has been brought", es: "La comida ha sido traída" }
      ]
    },
    { 
      infinitive: "write", 
      past: "wrote", 
      pastParticiple: "written", 
      translation: "escribir",
      emoji: "✍️",
      examples: [
        { en: "I write in my diary every day", es: "Escribo en mi diario todos los días" },
        { en: "He wrote a beautiful letter", es: "Él escribió una carta hermosa" },
        { en: "The book was written in 1985", es: "El libro fue escrito en 1985" }
      ]
    },
    { 
      infinitive: "run", 
      past: "ran", 
      pastParticiple: "run", 
      translation: "correr",
      emoji: "🏃‍♂️",
      examples: [
        { en: "I run every morning", es: "Corro todas las mañanas" },
        { en: "She ran to catch the bus", es: "Ella corrió para alcanzar el autobús" },
        { en: "The program has been run successfully", es: "El programa ha sido ejecutado exitosamente" }
      ]
    },
    { 
      infinitive: "sit", 
      past: "sat", 
      pastParticiple: "sat", 
      translation: "sentarse",
      emoji: "🪑",
      examples: [
        { en: "Please sit down", es: "Por favor siéntate" },
        { en: "He sat in the front row", es: "Él se sentó en la primera fila" },
        { en: "We have sat here for hours", es: "Hemos estado sentados aquí por horas" }
      ]
    },
    { 
      infinitive: "lose", 
      past: "lost", 
      pastParticiple: "lost", 
      translation: "perder",
      emoji: "🔍",
      examples: [
        { en: "I often lose my keys", es: "A menudo pierdo mis llaves" },
        { en: "They lost the game", es: "Ellos perdieron el juego" },
        { en: "The opportunity has been lost", es: "La oportunidad se ha perdido" }
      ]
    },
    { 
      infinitive: "pay", 
      past: "paid", 
      pastParticiple: "paid", 
      translation: "pagar",
      emoji: "💰",
      examples: [
        { en: "I pay my bills online", es: "Pago mis cuentas en línea" },
        { en: "She paid for dinner", es: "Ella pagó la cena" },
        { en: "The debt has been paid", es: "La deuda ha sido pagada" }
      ]
    },
    { 
      infinitive: "eat", 
      past: "ate", 
      pastParticiple: "eaten", 
      translation: "comer",
      emoji: "🍽️",
      examples: [
        { en: "I eat breakfast every day", es: "Desayuno todos los días" },
        { en: "We ate pizza last night", es: "Comimos pizza anoche" },
        { en: "The cake has been eaten", es: "El pastel ha sido comido" }
      ]
    },
    { 
      infinitive: "meet", 
      past: "met", 
      pastParticiple: "met", 
      translation: "conocer/encontrar",
      emoji: "🤝",
      examples: [
        { en: "I meet new people every day", es: "Conozco gente nueva todos los días" },
        { en: "We met at the conference", es: "Nos conocimos en la conferencia" },
        { en: "They have met before", es: "Se han conocido antes" }
      ]
    },
    { 
      infinitive: "set", 
      past: "set", 
      pastParticiple: "set", 
      translation: "establecer",
      emoji: "⚙️",
      examples: [
        { en: "I set my alarm for 7am", es: "Pongo mi alarma a las 7am" },
        { en: "She set a new record", es: "Ella estableció un nuevo récord" },
        { en: "The rules have been set", es: "Las reglas han sido establecidas" }
      ]
    },
    { 
      infinitive: "learn", 
      past: "learned/learnt", 
      pastParticiple: "learned/learnt", 
      translation: "aprender",
      emoji: "📚",
      examples: [
        { en: "I learn something new every day", es: "Aprendo algo nuevo todos los días" },
        { en: "He learned to drive last year", es: "Él aprendió a manejar el año pasado" },
        { en: "This skill has been learned through practice", es: "Esta habilidad se ha aprendido con práctica" }
      ]
    },
    { 
      infinitive: "lead", 
      past: "led", 
      pastParticiple: "led", 
      translation: "liderar",
      emoji: "👑",
      examples: [
        { en: "I lead the team meetings", es: "Lidero las reuniones del equipo" },
        { en: "She led the project successfully", es: "Ella lideró el proyecto exitosamente" },
        { en: "The company has been led by experts", es: "La empresa ha sido liderada por expertos" }
      ]
    },
    { 
      infinitive: "understand", 
      past: "understood", 
      pastParticiple: "understood", 
      translation: "entender",
      emoji: "💡",
      examples: [
        { en: "I understand the problem", es: "Entiendo el problema" },
        { en: "She understood the instructions", es: "Ella entendió las instrucciones" },
        { en: "The concept has been well understood", es: "El concepto ha sido bien entendido" }
      ]
    },
    { 
      infinitive: "speak", 
      past: "spoke", 
      pastParticiple: "spoken", 
      translation: "hablar",
      emoji: "🗣️",
      examples: [
        { en: "I speak three languages", es: "Hablo tres idiomas" },
        { en: "He spoke at the conference", es: "Él habló en la conferencia" },
        { en: "English is spoken worldwide", es: "El inglés se habla mundialmente" }
      ]
    },
    { 
      infinitive: "read", 
      past: "read", 
      pastParticiple: "read", 
      translation: "leer",
      emoji: "📖",
      examples: [
        { en: "I read books every night", es: "Leo libros todas las noches" },
        { en: "She read the entire book yesterday", es: "Ella leyó todo el libro ayer" },
        { en: "This book has been read millions of times", es: "Este libro ha sido leído millones de veces" }
      ]
    },
    { 
      infinitive: "spend", 
      past: "spent", 
      pastParticiple: "spent", 
      translation: "gastar",
      emoji: "💸",
      examples: [
        { en: "I spend time with my family", es: "Paso tiempo con mi familia" },
        { en: "We spent our vacation in Italy", es: "Pasamos nuestras vacaciones en Italia" },
        { en: "Too much money has been spent", es: "Se ha gastado demasiado dinero" }
      ]
    },
    { 
      infinitive: "grow", 
      past: "grew", 
      pastParticiple: "grown", 
      translation: "crecer",
      emoji: "🌱",
      examples: [
        { en: "Plants grow with sunlight", es: "Las plantas crecen con la luz solar" },
        { en: "The city grew rapidly", es: "La ciudad creció rápidamente" },
        { en: "He has grown taller this year", es: "Él ha crecido más alto este año" }
      ]
    },
    { 
      infinitive: "win", 
      past: "won", 
      pastParticiple: "won", 
      translation: "ganar",
      emoji: "🏆",
      examples: [
        { en: "I always win at chess", es: "Siempre gano al ajedrez" },
        { en: "Our team won the championship", es: "Nuestro equipo ganó el campeonato" },
        { en: "The prize has been won fairly", es: "El premio ha sido ganado justamente" }
      ]
    },
    { 
      infinitive: "buy", 
      past: "bought", 
      pastParticiple: "bought", 
      translation: "comprar",
      emoji: "🛒",
      examples: [
        { en: "I buy groceries every week", es: "Compro víveres todas las semanas" },
        { en: "She bought a new car", es: "Ella compró un carro nuevo" },
        { en: "The house was bought last year", es: "La casa fue comprada el año pasado" }
      ]
    },
    { 
      infinitive: "send", 
      past: "sent", 
      pastParticiple: "sent", 
      translation: "enviar",
      emoji: "📤",
      examples: [
        { en: "I send emails every day", es: "Envío correos todos los días" },
        { en: "He sent me a message", es: "Él me envió un mensaje" },
        { en: "The package has been sent", es: "El paquete ha sido enviado" }
      ]
    },
    { 
      infinitive: "build", 
      past: "built", 
      pastParticiple: "built", 
      translation: "construir",
      emoji: "🏗️",
      examples: [
        { en: "They build houses", es: "Ellos construyen casas" },
        { en: "We built a treehouse", es: "Construimos una casa del árbol" },
        { en: "The bridge was built in 1950", es: "El puente fue construido en 1950" }
      ]
    },
    { 
      infinitive: "fall", 
      past: "fell", 
      pastParticiple: "fallen", 
      translation: "caer",
      emoji: "🍂",
      examples: [
        { en: "Leaves fall in autumn", es: "Las hojas caen en otoño" },
        { en: "She fell off her bike", es: "Ella se cayó de su bicicleta" },
        { en: "The temperature has fallen", es: "La temperatura ha bajado" }
      ]
    },
    { 
      infinitive: "cut", 
      past: "cut", 
      pastParticiple: "cut", 
      translation: "cortar",
      emoji: "✂️",
      examples: [
        { en: "I cut vegetables for dinner", es: "Corto verduras para la cena" },
        { en: "He cut his finger", es: "Él se cortó el dedo" },
        { en: "The tree has been cut down", es: "El árbol ha sido cortado" }
      ]
    },
    { 
      infinitive: "sell", 
      past: "sold", 
      pastParticiple: "sold", 
      translation: "vender",
      emoji: "💰",
      examples: [
        { en: "We sell fresh fruit", es: "Vendemos fruta fresca" },
        { en: "They sold their house", es: "Ellos vendieron su casa" },
        { en: "All tickets have been sold", es: "Todas las entradas han sido vendidas" }
      ]
    },
    // Verbos irregulares adicionales importantes
    { 
      infinitive: "fly", 
      past: "flew", 
      pastParticiple: "flown", 
      translation: "volar",
      emoji: "✈️",
      examples: [
        { en: "Birds fly in the sky", es: "Los pájaros vuelan en el cielo" },
        { en: "We flew to Paris last month", es: "Volamos a París el mes pasado" },
        { en: "The plane has flown over the mountains", es: "El avión ha volado sobre las montañas" }
      ]
    },
    { 
      infinitive: "drive", 
      past: "drove", 
      pastParticiple: "driven", 
      translation: "conducir",
      emoji: "🚗",
      examples: [
        { en: "I drive to work every day", es: "Manejo al trabajo todos los días" },
        { en: "She drove through the city", es: "Ella manejó por la ciudad" },
        { en: "The car has been driven 100,000 miles", es: "El carro ha sido manejado 100,000 millas" }
      ]
    },
    { 
      infinitive: "draw", 
      past: "drew", 
      pastParticiple: "drawn", 
      translation: "dibujar",
      emoji: "🎨",
      examples: [
        { en: "I draw pictures in my free time", es: "Dibujo en mi tiempo libre" },
        { en: "He drew a beautiful landscape", es: "Él dibujó un paisaje hermoso" },
        { en: "The plans have been drawn by an architect", es: "Los planos han sido dibujados por un arquitecto" }
      ]
    },
    { 
      infinitive: "break", 
      past: "broke", 
      pastParticiple: "broken", 
      translation: "romper",
      emoji: "💔",
      examples: [
        { en: "Don't break the glass", es: "No rompas el vidrio" },
        { en: "He broke his leg skiing", es: "Él se rompió la pierna esquiando" },
        { en: "The window has been broken", es: "La ventana ha sido rota" }
      ]
    },
    { 
      infinitive: "catch", 
      past: "caught", 
      pastParticiple: "caught", 
      translation: "atrapar",
      emoji: "🤲",
      examples: [
        { en: "I catch the ball", es: "Atrapo la pelota" },
        { en: "She caught a cold", es: "Ella se resfriú" },
        { en: "The thief has been caught", es: "El ladrón ha sido atrapado" }
      ]
    },
    { 
      infinitive: "choose", 
      past: "chose", 
      pastParticiple: "chosen", 
      translation: "elegir",
      emoji: "🤔",
      examples: [
        { en: "I choose healthy food", es: "Elijo comida saludable" },
        { en: "They chose the best option", es: "Ellos eligieron la mejor opción" },
        { en: "The winner has been chosen", es: "El ganador ha sido elegido" }
      ]
    },
    { 
      infinitive: "sleep", 
      past: "slept", 
      pastParticiple: "slept", 
      translation: "dormir",
      emoji: "😴",
      examples: [
        { en: "I sleep eight hours every night", es: "Duermo ocho horas todas las noches" },
        { en: "The baby slept peacefully", es: "El bebé durmió tranquilamente" },
        { en: "He has slept for 12 hours", es: "Él ha dormido por 12 horas" }
      ]
    },
    { 
      infinitive: "swim", 
      past: "swam", 
      pastParticiple: "swum", 
      translation: "nadar",
      emoji: "🏊‍♂️",
      examples: [
        { en: "I swim in the pool every morning", es: "Nado en la piscina todas las mañanas" },
        { en: "She swam across the lake", es: "Ella nadó a través del lago" },
        { en: "The race has been swum in record time", es: "La carrera ha sido nadada en tiempo récord" }
      ]
    },
    { 
      infinitive: "teach", 
      past: "taught", 
      pastParticiple: "taught", 
      translation: "enseñar",
      emoji: "👨‍🏫",
      examples: [
        { en: "I teach English to children", es: "Enseño inglés a niños" },
        { en: "My mother taught me to cook", es: "Mi madre me enseñó a cocinar" },
        { en: "This subject has been taught for years", es: "Esta materia ha sido enseñada por años" }
      ]
    }
  ],

  // PLACES TO GO OUT - NEW SECTION
  placesToGoOut: [
    {
      id: "places_city",
      tema: "In the City",
      estructura: "Places + Activities",
      ejemplo: "Let's go to the movies and watch a film",
      traduccion: "Vamos al cine y veamos una película",
      uso: "Para hablar de lugares en la ciudad y actividades"
    },
    {
      id: "places_outside",
      tema: "Outside the City",
      estructura: "Natural places + Outdoor activities", 
      ejemplo: "We went to the beach and had a picnic",
      traduccion: "Fuimos a la playa e hicimos un picnic",
      uso: "Para hablar de lugares fuera de la ciudad"
    },
    {
      id: "city_places_list",
      tema: "City Places",
      estructura: "the Park, the Movies, the Zoo, a restaurant, a disco, the Amusement Park, the Museum, a play, the Art Gallery, a concert, a fair, a carnival, a garage sale, the flea market, the Planetarium, the Aquarium",
      ejemplo: "I love going to the museum on weekends",
      traduccion: "Me encanta ir al museo los fines de semana",
      uso: "Lugares comunes en la ciudad para entretenimiento"
    },
    {
      id: "city_activities",
      tema: "City Activities",
      estructura: "watching movies, eating popcorn and nachos, eating delicious food, dancing, driving bumper cars, riding roller coaster and ferris wheel, watching art, enjoying live performances, buying second hand furniture, watching the stars, watching fish",
      ejemplo: "We spent the day riding the roller coaster",
      traduccion: "Pasamos el día montando la montaña rusa",
      uso: "Actividades típicas en lugares de la ciudad"
    },
    {
      id: "outside_places",
      tema: "Outside City Places",
      estructura: "the beach, the mountains, the botanical gardens, a National Park, a historic site, the lake, the forest, the farm, a camp field, the river, a volcano",
      ejemplo: "The national park has amazing hiking trails",
      traduccion: "El parque nacional tiene senderos increíbles",
      uso: "Lugares naturales fuera de la ciudad"
    },
    {
      id: "outdoor_activities",
      tema: "Outdoor Activities",
      estructura: "picnic, roller blading, skating, walking pets, sunbathing, surfing, birdwatching, hiking, walking, jogging, watching butterflies and flowers, visiting monuments, taking pictures, fishing, sailing, windsurfing, going camping",
      ejemplo: "We love hiking in the mountains during summer",
      traduccion: "Nos encanta hacer senderismo en las montañas durante el verano",
      uso: "Actividades al aire libre y deportes"
    }
  ],

  // NUMBERS AND DATES - NEW SECTION
  numbersAndDates: [
    {
      id: "months_year",
      tema: "Months of the Year",
      estructura: "January-Jan (31), February-Feb (28-29), March-Mar (31), April-Apr (30), May-May (31), June-Jun (30), July-Jul (31), August-Aug (31), September-Sep (30), October-Oct (31), November-Nov (30), December-Dec (31)",
      ejemplo: "My birthday is in January and Christmas is in December",
      traduccion: "Mi cumpleaños es en enero y Navidad es en diciembre",
      uso: "Meses del año con abreviaciones y días"
    },
    {
      id: "cardinal_numbers",
      tema: "Cardinal Numbers 1-31",
      estructura: "1(one), 2(two), 3(three), 4(four), 5(five), 6(six), 7(seven), 8(eight), 9(nine), 10(ten), 11(eleven), 12(twelve), 13(thirteen), 14(fourteen), 15(fifteen), 16(sixteen), 17(seventeen), 18(eighteen), 19(nineteen), 20(twenty), 21(twenty one), 22(twenty two), 23(twenty three), 24(twenty four), 30(thirty), 31(thirty one)",
      ejemplo: "Today is the twenty-first of March",
      traduccion: "Hoy es veintiuno de marzo",
      uso: "Números cardinales para fechas y cantidades"
    },
    {
      id: "ordinal_numbers",
      tema: "Ordinal Numbers 1st-31st",
      estructura: "1st(first), 2nd(second), 3rd(third), 4th(fourth), 5th(fifth), 6th(sixth), 7th(seventh), 8th(eighth), 9th(ninth), 10th(tenth), 11th(eleventh), 12th(twelfth), 13th(thirteenth), 14th(fourteenth), 15th(fifteenth), 16th(sixteenth), 17th(seventeenth), 18th(eighteenth), 19th(nineteenth), 20th(twentieth), 21st(twenty first), 22nd(twenty second), 23rd(twenty third), 24th(twenty fourth), 30th(thirtieth), 31st(thirty first)",
      ejemplo: "My birthday is on the fifteenth of June",
      traduccion: "Mi cumpleaños es el quince de junio",
      uso: "Números ordinales para fechas específicas"
    },
    {
      id: "date_prepositions",
      tema: "Date Prepositions",
      estructura: "in + month/year, on + complete date, on + day + ordinal",
      ejemplo: "I was born in 1990, on January 6th / in January",
      traduccion: "Nací en 1990, el 6 de enero / en enero",
      uso: "Preposiciones correctas para fechas"
    },
    {
      id: "date_reading",
      tema: "Reading Dates",
      estructura: "July 4th = the fourth of July OR July fourth",
      ejemplo: "Independence Day is July 4th (the fourth of July)",
      traduccion: "El día de la independencia es el 4 de julio",
      uso: "Diferentes formas de leer fechas en inglés"
    }
  ],

  // ADDITIONS TO REMARK - NEW SECTION  
  additionsToRemark: [
    {
      id: "too_so_positive",
      tema: "Too / So (Positive)",
      estructura: "Subject + auxiliary + too / So + auxiliary + subject",
      ejemplo: "I love music and John does too / So does John",
      traduccion: "Me gusta la música y a John también",
      uso: "Para mostrar acuerdo en oraciones positivas"
    },
    {
      id: "either_neither_negative", 
      tema: "Either / Neither (Negative)",
      estructura: "Subject + auxiliary + either / Neither + auxiliary + subject",
      ejemplo: "I don't like salsa and Maria doesn't either / Neither does Maria",
      traduccion: "No me gusta la salsa y a Maria tampoco",
      uso: "Para mostrar acuerdo en oraciones negativas"
    },
    {
      id: "either_or",
      tema: "Either...or",
      estructura: "Either + option 1 + or + option 2",
      ejemplo: "We can eat either meat or chicken",
      traduccion: "Podemos comer carne o pollo",
      uso: "Para dar dos opciones positivas"
    },
    {
      id: "neither_nor",
      tema: "Neither...nor",
      estructura: "Neither + option 1 + nor + option 2",
      ejemplo: "There are neither taxis nor buses at this time",
      traduccion: "No hay ni taxis ni autobuses a esta hora",
      uso: "Para negar dos opciones"
    },
    {
      id: "responses_agreement",
      tema: "Agreement Responses",
      estructura: "A: Statement / B: Agreement response",
      ejemplo: "A: I love pizza / B: So do I! / Me too!",
      traduccion: "A: Me encanta la pizza / B: ¡A mí también!",
      uso: "Para responder mostrando acuerdo rápidamente"
    }
  ],

  // CLOTHING VOCABULARY - NEW SECTION
  clothingVocabulary: [
    {
      id: "head_accessories",
      tema: "Head & Accessories",
      estructura: "hat, cap, sweatband, glasses, sunglasses, hair clip, earrings",
      ejemplo: "She's wearing sunglasses and a beautiful hat",
      traduccion: "Ella lleva gafas de sol y un sombrero hermoso",
      uso: "Ropa y accesorios para la cabeza"
    },
    {
      id: "jewelry_accessories",
      tema: "Jewelry & Personal Items",
      estructura: "ring, bracelet, necklace, chain, wallet, purse, handkerchief, key chain, handbag",
      ejemplo: "I lost my bracelet and my wallet yesterday",
      traduccion: "Perdí mi pulsera y mi billetera ayer",
      uso: "Joyas y artículos personales"
    },
    {
      id: "upper_body_clothing",
      tema: "Upper Body Clothing",
      estructura: "blouse, shirt, t-shirt, sweater, scarf, turtleneck, vest, jacket, overcoat, blazer",
      ejemplo: "It's cold, so I'm wearing a sweater and jacket",
      traduccion: "Hace frío, así que llevo suéter y chaqueta",
      uso: "Ropa para la parte superior del cuerpo"
    },
    {
      id: "lower_body_clothing",
      tema: "Lower Body Clothing",
      estructura: "skirt, pants, jeans, shorts, belt, leggings, tights",
      ejemplo: "These jeans are too tight, I need a bigger size",
      traduccion: "Estos jeans están muy ajustados, necesito una talla más grande",
      uso: "Ropa para la parte inferior del cuerpo"
    },
    {
      id: "formal_clothing",
      tema: "Formal Clothing",
      estructura: "dress, suit, tie, formal shoes, heels",
      ejemplo: "He wore a black suit and red tie to the wedding",
      traduccion: "Él usó un traje negro y corbata roja para la boda",
      uso: "Ropa formal para eventos especiales"
    },
    {
      id: "footwear",
      tema: "Footwear",
      estructura: "shoes, heels, tennis shoes, sandals, flip-flops, boots, moccasins",
      ejemplo: "I prefer tennis shoes for running and boots for hiking",
      traduccion: "Prefiero zapatos deportivos para correr y botas para senderismo",
      uso: "Diferentes tipos de calzado"
    },
    {
      id: "underwear",
      tema: "Underwear",
      estructura: "panties, briefs, boxers, socks, bra, undershirt, stockings",
      ejemplo: "Don't forget to pack clean socks and underwear",
      traduccion: "No olvides empacar calcetines y ropa interior limpios",
      uso: "Ropa interior y prendas básicas"
    }
  ],

  // COMPARATIVES AND SUPERLATIVES - EXPANDED
  comparativesSuperlatives: [
    {
      id: "short_adjectives",
      tema: "Short Adjectives (1-2 syllables)",
      estructura: "adj + er + than / the + adj + est",
      ejemplo: "John is taller than Mike / John is the tallest in class",
      traduccion: "John es más alto que Mike / John es el más alto de la clase",
      uso: "Para adjetivos cortos, agregar -er/-est"
    },
    {
      id: "long_adjectives",
      tema: "Long Adjectives (3+ syllables)",
      estructura: "more + adj + than / the most + adj",
      ejemplo: "This is more expensive than that / This is the most expensive",
      traduccion: "Esto es más caro que eso / Esto es lo más caro",
      uso: "Para adjetivos largos, usar more/most"
    },
    {
      id: "irregular_comparatives",
      tema: "Irregular Comparatives",
      estructura: "good-better-best / bad-worse-worst / far-farther-farthest",
      ejemplo: "This pizza is better than yesterday's / It's the best pizza ever",
      traduccion: "Esta pizza está mejor que la de ayer / Es la mejor pizza",
      uso: "Comparativos irregulares que cambian completamente"
    },
    {
      id: "as_as_comparisons",
      tema: "As...as / Less...than",
      estructura: "as + adj + as / less + adj + than",
      ejemplo: "Cars aren't as fast as planes / Planes are less comfortable than cars",
      traduccion: "Los autos no son tan rápidos como los aviones",
      uso: "Para comparaciones de igualdad o inferioridad"
    },
    {
      id: "double_comparatives",
      tema: "Double Comparatives",
      estructura: "The + comparative, the + comparative",
      ejemplo: "The funnier the movie, the more I enjoy it",
      traduccion: "Mientras más graciosa la película, más la disfruto",
      uso: "Para mostrar que dos cosas cambian juntas"
    },
    {
      id: "spelling_rules",
      tema: "Spelling Rules",
      estructura: "CVC: big-bigger / y: happy-happier / e: nice-nicer",
      ejemplo: "hot-hotter-hottest / easy-easier-easiest",
      traduccion: "Reglas de escritura para comparativos",
      uso: "Reglas especiales de escritura al agregar -er/-est"
    }
  ],

  // RESTAURANT MENU VOCABULARY - NEW SECTION
  restaurantMenu: [
    {
      id: "appetizers",
      tema: "Appetizers",
      estructura: "fruit cocktail, ceviche, buffalo wings, mozzarella sticks, onion rings",
      ejemplo: "Let's start with some buffalo wings as appetizers",
      traduccion: "Empecemos con unas alitas búfalo como aperitivos",
      uso: "Entradas y aperitivos para comenzar la comida"
    },
    {
      id: "salads",
      tema: "Salads",
      estructura: "Caesar salad, green salad, spinach chicken salad, mushroom salad, chef salad, seafood salad",
      ejemplo: "I'll have the Caesar salad with extra dressing",
      traduccion: "Voy a pedir la ensalada César con aderezo extra",
      uso: "Diferentes tipos de ensaladas disponibles"
    },
    {
      id: "entrees",
      tema: "Main Entrees",
      estructura: "grilled chicken breast, pasta, BBQ pork ribs, fish and chips, chicken fajitas, beef stew",
      ejemplo: "The grilled chicken breast comes with vegetables",
      traduccion: "La pechuga de pollo a la parrilla viene con vegetales",
      uso: "Platos principales del menú"
    },
    {
      id: "side_dishes",
      tema: "Side Dishes",
      estructura: "fries, rice, mixed vegetables, baked potato, mashed potatoes, tortilla",
      ejemplo: "Would you like fries or rice as your side dish?",
      traduccion: "¿Quisieras papas fritas o arroz como acompañamiento?",
      uso: "Acompañamientos para los platos principales"
    },
    {
      id: "desserts",
      tema: "Desserts",
      estructura: "chocolate mousse cake, apple pie, ice cream cup, jello, pudding, cheese cake, chocolate chip cookie",
      ejemplo: "For dessert, I recommend the chocolate mousse cake",
      traduccion: "Para el postre, recomiendo el pastel de mousse de chocolate",
      uso: "Postres disponibles en el restaurante"
    },
    {
      id: "beverages",
      tema: "Beverages",
      estructura: "pop, hot chocolate, iced tea, lemonade, coffee, tea, milkshake",
      ejemplo: "I'll have an iced tea and she wants a milkshake",
      traduccion: "Yo voy a tomar té helado y ella quiere un batido",
      uso: "Bebidas disponibles en el menú"
    }
  ],

  // TAG QUESTIONS - EXPANDED
  tagQuestionsExpanded: [
    {
      id: "positive_negative_tags",
      tema: "Positive Statement + Negative Tag",
      estructura: "Positive statement + negative auxiliary + pronoun",
      ejemplo: "You are a member of this gym, aren't you?",
      traduccion: "Eres miembro de este gimnasio, ¿verdad?",
      uso: "Oraciones positivas llevan tag negativo"
    },
    {
      id: "negative_positive_tags",
      tema: "Negative Statement + Positive Tag",
      estructura: "Negative statement + positive auxiliary + pronoun",
      ejemplo: "You're not my girlfriend, are you?",
      traduccion: "No eres mi novia, ¿o sí?",
      uso: "Oraciones negativas llevan tag positivo"
    },
    {
      id: "reply_questions",
      tema: "Reply Questions",
      estructura: "A: Statement / B: Auxiliary + subject + ?",
      ejemplo: "A: I have a fever / B: Do you?",
      traduccion: "A: Tengo fiebre / B: ¿En serio?",
      uso: "Para mostrar sorpresa o confirmar información"
    },
    {
      id: "tag_with_modals",
      tema: "Tags with Modal Verbs",
      estructura: "Modal statement + modal tag",
      ejemplo: "You should come early, shouldn't you?",
      traduccion: "Deberías venir temprano, ¿no deberías?",
      uso: "Tags con verbos modales mantienen el modal"
    },
    {
      id: "tag_with_perfect",
      tema: "Tags with Perfect Tenses",
      estructura: "Perfect statement + have/has tag",
      ejemplo: "It has been down, hasn't it?",
      traduccion: "Ha estado abajo, ¿no es así?",
      uso: "Tags con tiempos perfectos usan have/has"
    }
  ],

  // FOOD PREPARATION - NEW SECTION
  foodPreparation: [
    {
      id: "measurements",
      tema: "Units of Measurement",
      estructura: "a cup, a bowl, a teaspoon, a tablespoon, a liter, a bag, a bottle, a box, a bunch, a can, a carton, a dozen, a head, a jar, a pack, a package, a six-pack, a stick",
      ejemplo: "Add two cups of flour and a teaspoon of salt",
      traduccion: "Agrega dos tazas de harina y una cucharadita de sal",
      uso: "Unidades de medida para cocinar"
    },
    {
      id: "preparation_verbs",
      tema: "Food Preparation Verbs",
      estructura: "prepare, make, cook, bake, grate, peel, skin, break, sprinkle, mix, blend, put, cut, chop, dice, slice, beat, stir, pour, add, boil, fry, grill, microwave",
      ejemplo: "First peel the potatoes, then chop them into small pieces",
      traduccion: "Primero pela las papas, luego córtalas en pedazos pequeños",
      uso: "Verbos para preparar y cocinar alimentos"
    },
    {
      id: "recipe_sequence",
      tema: "Recipe Sequence Words",
      estructura: "first, second, third, next, then, after that, when, finally",
      ejemplo: "First mix the ingredients, then bake for 30 minutes",
      traduccion: "Primero mezcla los ingredientes, luego hornea por 30 minutos",
      uso: "Palabras de secuencia para recetas"
    },
    {
      id: "fractions_cooking",
      tema: "Fractions in Cooking",
      estructura: "one (1), half (1/2), a quarter (1/4), a third (1/3), two thirds (2/3)",
      ejemplo: "Use half a cup of sugar and a quarter cup of butter",
      traduccion: "Usa media taza de azúcar y un cuarto de taza de mantequilla",
      uso: "Fracciones comunes en recetas de cocina"
    }
  ],

  // CONDITIONALS - ALL THREE TYPES EXPANDED
  conditionalsExpanded: [
    {
      id: "first_conditional_real",
      tema: "First Conditional (Real/Possible)",
      estructura: "If + present simple, will + infinitive",
      ejemplo: "If it rains tomorrow, we will stay home",
      traduccion: "Si llueve mañana, nos quedaremos en casa",
      uso: "Para situaciones reales o muy posibles en el futuro"
    },
    {
      id: "first_conditional_unless",
      tema: "First Conditional with Unless",
      estructura: "Unless + present simple, will + infinitive",
      ejemplo: "Unless our team scores more goals, it won't win",
      traduccion: "A menos que nuestro equipo anote más goles, no ganará",
      uso: "Unless = if not, para condiciones negativas"
    },
    {
      id: "second_conditional_unreal",
      tema: "Second Conditional (Unreal/Unlikely)",
      estructura: "If + past simple, would + infinitive",
      ejemplo: "If I were rich, I would travel around the world",
      traduccion: "Si fuera rico, viajaría por todo el mundo",
      uso: "Para situaciones irreales o muy improbables"
    },
    {
      id: "second_conditional_advice",
      tema: "Second Conditional for Advice",
      estructura: "If I were you, I would...",
      ejemplo: "If I were you, I would study harder for the exam",
      traduccion: "Si fuera tú, estudiaría más para el examen",
      uso: "Para dar consejos usando el segundo condicional"
    },
    {
      id: "third_conditional_past",
      tema: "Third Conditional (Past Regrets)",
      estructura: "If + past perfect, would have + past participle",
      ejemplo: "If I had studied harder, I would have passed the exam",
      traduccion: "Si hubiera estudiado más, habría pasado el examen",
      uso: "Para situaciones que no pasaron en el pasado"
    },
    {
      id: "mixed_conditionals",
      tema: "Mixed Conditionals",
      estructura: "If + past perfect, would + infinitive",
      ejemplo: "If I had taken that job, I would be rich now",
      traduccion: "Si hubiera tomado ese trabajo, sería rico ahora",
      uso: "Mezcla pasado con presente para mostrar efectos actuales"
    }
  ],

  // EXERCISE AND FITNESS - NEW SECTION
  exerciseFitness: [
    {
      id: "gym_equipment",
      tema: "Gym Equipment",
      estructura: "treadmill, stationary bikes, dumbbell, coach, stopwatch",
      ejemplo: "I spent 30 minutes on the treadmill this morning",
      traduccion: "Pasé 30 minutos en la cinta de correr esta mañana",
      uso: "Equipos comunes en el gimnasio"
    },
    {
      id: "fitness_activities",
      tema: "Fitness Activities",
      estructura: "bodybuilding, running, weight lifting, aerobics, circuit training, cardio, stretching, toning",
      ejemplo: "I prefer cardio exercises over weight lifting",
      traduccion: "Prefiero ejercicios cardio sobre levantamiento de pesas",
      uso: "Diferentes tipos de actividades físicas"
    },
    {
      id: "exercise_movements",
      tema: "Exercise Movements",
      estructura: "pushups, pullups, squats, plank, burpees, jumping jacks",
      ejemplo: "Do 20 pushups and then 15 squats",
      traduccion: "Haz 20 flexiones y luego 15 sentadillas",
      uso: "Movimientos específicos de ejercicio"
    },
    {
      id: "fitness_terms",
      tema: "Fitness Terms",
      estructura: "reps, sets, tempo, warm up, cool-down, intensity, membership, trainer, instructor, diet plan, nutrition",
      ejemplo: "Do 3 sets of 10 reps with proper tempo",
      traduccion: "Haz 3 series de 10 repeticiones con ritmo apropiado",
      uso: "Términos técnicos del fitness y ejercicio"
    },
    {
      id: "weight_goals",
      tema: "Weight & Fitness Goals",
      estructura: "weight loss, fitness, jogging, swimming, sportswear",
      ejemplo: "My goal is weight loss through swimming and jogging",
      traduccion: "Mi meta es perder peso a través de natación y trotar",
      uso: "Objetivos relacionados con peso y estado físico"
    }
  ],

  // TV SHOWS AND ENTERTAINMENT - NEW SECTION
  tvEntertainment: [
    {
      id: "tv_genres",
      tema: "TV Show Genres",
      estructura: "Movies, Cartoons, History, Sports, Music, Health, Geography, Children, Reality shows, Documentaries, Biographies, Education, Wildlife, News",
      ejemplo: "I love watching documentaries about wildlife",
      traduccion: "Me encanta ver documentales sobre vida silvestre",
      uso: "Diferentes géneros de programas de televisión"
    },
    {
      id: "movie_types",
      tema: "Movie Types",
      estructura: "action, comedy, drama, horror, thriller, romance, sci-fi, fantasy, animation, documentary",
      ejemplo: "Let's watch a comedy movie tonight",
      traduccion: "Veamos una película de comedia esta noche",
      uso: "Tipos de películas disponibles"
    },
    {
      id: "tv_vocabulary",
      tema: "TV Vocabulary",
      estructura: "channel, remote control, volume, episode, season, series, premiere, finale",
      ejemplo: "Change the channel, this episode is boring",
      traduccion: "Cambia el canal, este episodio está aburrido",
      uso: "Vocabulario relacionado con televisión"
    },
    {
      id: "entertainment_preferences",
      tema: "Entertainment Preferences",
      estructura: "I prefer... / I enjoy... / I can't stand... / My favorite is...",
      ejemplo: "I prefer documentaries to reality shows",
      traduccion: "Prefiero documentales a reality shows",
      uso: "Para expresar preferencias de entretenimiento"
    }
  ],

  // MEDICAL VOCABULARY - NEW SECTION
  medicalVocabulary: [
    {
      id: "medical_workers",
      tema: "Medical Workers",
      estructura: "doctor, nurse, pediatrician, surgeon, physical therapist, allergist, ENT specialist, gastroenterologist, gynecologist, ophthalmologist, orthodontist, therapist, cardiologist, orthopedist, chiropractor, acupuncturist, anesthesiologist, gerontologist, audiologist, dietitian",
      ejemplo: "I need to see a cardiologist for my heart problem",
      traduccion: "Necesito ver a un cardiólogo por mi problema del corazón",
      uso: "Diferentes especialistas médicos"
    },
    {
      id: "body_parts",
      tema: "Parts of the Body",
      estructura: "head, hair, face, forehead, eyebrows, eyes, ears, nose, cheeks, jaw, chin, mouth, lips, teeth, tongue, neck, shoulders, arms, elbows, wrists, palms, fingers, finger nails, chest, breasts, belly, waist, hips, buttocks, legs, knees, ankles, feet, toes, toe nails",
      ejemplo: "My head hurts and my shoulders are tense",
      traduccion: "Me duele la cabeza y tengo los hombros tensos",
      uso: "Partes del cuerpo humano"
    },
    {
      id: "symptoms",
      tema: "Symptoms",
      estructura: "tired, sleepy, exhausted, sick, ill, hot, cold, hungry, thirsty, full, sad, unhappy",
      ejemplo: "I feel tired and sick, I think I have the flu",
      traduccion: "Me siento cansado y enfermo, creo que tengo gripe",
      uso: "Síntomas generales y estados físicos"
    },
    {
      id: "ailments",
      tema: "Ailments & Illnesses",
      estructura: "headache, earache, toothache, stomachache, backache, sore throat, fever, temperature, cold, cough, infection, chills, chest pain, shortness of breath, faint, dizzy, nauseous, congested, sneeze, burp, bleed, rash, insect bite, sunburn, runny nose, bloody nose, cavity, hiccups, diarrhea, laryngitis, vomit, throw up",
      ejemplo: "I have a terrible headache and a sore throat",
      traduccion: "Tengo un dolor de cabeza terrible y dolor de garganta",
      uso: "Enfermedades y dolencias comunes"
    },
    {
      id: "injuries",
      tema: "Injuries",
      estructura: "scratch, scrape, bruise, burn, hurt, cut, sprain, dislocate, break, swollen, injured, stroke, heart attack, allergic reaction, drug overdose, fall, unconscious",
      ejemplo: "I think I sprained my ankle when I fell",
      traduccion: "Creo que me torcí el tobillo cuando me caí",
      uso: "Lesiones y accidentes"
    },
    {
      id: "medicine",
      tema: "Medicine",
      estructura: "aspirin, pill, tablets, capsule, caplet, vitamins, cough syrup, throat lozenges, antacid tablets, nasal spray, eye drops, ointment, cream, lotion",
      ejemplo: "Take two aspirin and use this cough syrup",
      traduccion: "Toma dos aspirinas y usa este jarabe para la tos",
      uso: "Medicamentos y tratamientos"
    },
    {
      id: "medical_advice",
      tema: "Medical Advice",
      estructura: "Rest in bed, Drink a lot of fluids, Exercise, Go on a diet, See a specialist",
      ejemplo: "The doctor said to rest in bed and drink fluids",
      traduccion: "El doctor dijo que descansara en cama y tomara líquidos",
      uso: "Consejos médicos comunes"
    }
  ],

  // PERFECT TENSES - NEW SECTION
  perfectTenses: [
    {
      id: "present_perfect_structure",
      tema: "Present Perfect Structure",
      estructura: "Subject + have/has + past participle",
      ejemplo: "I have lived here for 5 years / She has eaten sushi before",
      traduccion: "He vivido aquí por 5 años / Ella ha comido sushi antes",
      uso: "Para experiencias pasadas que conectan con el presente"
    },
    {
      id: "past_perfect_structure",
      tema: "Past Perfect Structure",
      estructura: "Subject + had + past participle",
      ejemplo: "I had finished my homework before dinner",
      traduccion: "Había terminado mi tarea antes de la cena",
      uso: "Para acciones completadas antes de otro momento en el pasado"
    },
    {
      id: "present_perfect_vs_past",
      tema: "Present Perfect vs Simple Past",
      estructura: "Present Perfect: connection to now / Simple Past: finished time",
      ejemplo: "I have been to Paris (experience) / I went to Paris in 2020 (specific time)",
      traduccion: "He estado en París / Fui a París en 2020",
      uso: "Diferencia entre presente perfecto y pasado simple"
    },
    {
      id: "perfect_progressive",
      tema: "Perfect Progressive",
      estructura: "Subject + have/has/had + been + verb-ing",
      ejemplo: "I have been studying English for 3 years",
      traduccion: "He estado estudiando inglés por 3 años",
      uso: "Para acciones que empezaron en el pasado y continúan"
    },
    {
      id: "perfect_time_expressions",
      tema: "Time Expressions with Perfect",
      estructura: "just, already, yet, never, ever, recently, lately, still, for, since",
      ejemplo: "I have just finished / I haven't done it yet / I have never been there",
      traduccion: "Acabo de terminar / Aún no lo he hecho / Nunca he estado allí",
      uso: "Expresiones de tiempo específicas para tiempos perfectos"
    }
  ]
};
